"use client";

import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

export function WarningResourceCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={twMerge(
        "flex items-center gap-x-2 rounded-3xl bg-white px-4 py-2 shadow-sm ring-1 ring-gray-900/5",
        className
      )}
    >
      <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0 text-red-600" />
      <div className="flex-grow">{children}</div>
    </div>
  );
}
